import type { SetupStep1Input, SetupStep2Input, SetupStep3Input } from '@app/contracts';
import { create } from 'zustand';

interface SetupWizardState {
  step: 1 | 2 | 3;
  step1: Partial<SetupStep1Input>;
  step2: Partial<SetupStep2Input>;
  step3: Partial<SetupStep3Input>;
  setStep: (step: 1 | 2 | 3) => void;
  setStep1: (data: SetupStep1Input) => void;
  setStep2: (data: SetupStep2Input) => void;
  setStep3: (data: SetupStep3Input) => void;
  reset: () => void;
}

export const useSetupWizardStore = create<SetupWizardState>((set) => ({
  step: 1,
  step1: {},
  step2: {},
  step3: { sites: [], preferredSiteIndex: 0 },
  setStep: (step) => set({ step }),
  setStep1: (data) => set({ step1: data, step: 2 }),
  setStep2: (data) => set({ step2: data, step: 3 }),
  setStep3: (data) => set({ step3: data }),
  reset: () => set({ step: 1, step1: {}, step2: {}, step3: { sites: [], preferredSiteIndex: 0 } }),
}));
